<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
import { mapState } from "vuex";
import wlArticle from "@/components/wl-article";
export default {
  components: { wlArticle },
  data() {
    return {
      searchWord: null,

      articleRefreshLoading: false, //刷新
      articleLoading: false, //加载
      articleFinished: false, //加载完成
      articleList: [],
      pagination: {
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },

      timeout: null,

      tid: null,
      tInfo:{},
    };
  },
  computed: {
    ...mapState(["userInfo", "authToken"]),
  },
  watch: {},
  created: function () {},
  mounted: function () {
    this.tid = this.$route.query.tid;
    if(!this.tid){
      this.$router.back();
    }
    //获取详情
    this.$api.topicDetail({id:this.tid}).then(res=>{
      this.tInfo = res.data;
    })
  },
  methods: {
    //筛选医生
    onFilter(e){
      var v = e.target.value;
      if(this.$glf.isEmpty(v)){
        return false;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(()=>{
        this.refreshArticle();
      },500)
    },
    //刷新文章
    refreshArticle() {
      this.articleFinished = false;
      this.pagination.index = 0;
      this.loadArticle().then((res) => {
        this.articleRefreshLoading = false;
      });
    },
    //加载文章
    loadArticle() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index + 1,
          size: this.pagination.size,
        },
        // sort: [{ code: "publishDtm", desc: true }],
        condition: {
          stc: "1",
          items: [{ code: "topicId", opc: "=", values: [this.tid] }],
        },
      };
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.$api.articleTopicPage(params).then((res) => {
          var data = res.data;
          var list = data.data || [];
          list.map((r) => {
            if (r.imgs) {
              r.imgs = JSON.parse(r.imgs);
            } else {
              r.imgs = [];
            }
            return r;
          });
          if (data.pagination.index === 1) {
            _this.articleList = list;
          } else {
            _this.articleList = _this.articleList.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.articleList.length >= _this.pagination.total) {
            _this.articleFinished = true;
          }
          // 加载状态结束
          _this.articleLoading = false;
          resolve();
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/topic/index.vue